














































































































import Vue from "vue";
import { authentication } from "@/stores";
import firebaseProject from "@/common/firebaseProject";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";

const db = firebaseProject.firestore();
export default shopBase.extend(Vue).extend({
  name: "Access",
  mixins: [],
  data(): {
    authentication: object;
    transitionName: string;
    startDate: Date;
    endDate: Date;
    modelConfig: {
      start: {
        timeAdjust: string;
      };
      end: {
        timeAdjust: string;
      };
    };
    lastday: string;
    parPage: number;
    currentPage: number;
    showDialog: boolean;
    listItem: object[];
    total: number;
    listLoading: boolean;
    dialoglistItem: object[];
  } {
    const nowH = parseInt(dayjs().format("H"));
    let todayD = dayjs();
    if (nowH <= 4) {
      todayD = dayjs().add(-1, "day");
    }
    const alldayStart = todayD.add(-7, "d").format("YYYYMMDD");
    const queryStart = this.$route.query.start
      ? String(this.$route.query.start)
      : alldayStart;
    const queryEnd = this.$route.query.end
      ? String(this.$route.query.end)
      : todayD.add(-1, "d").format("YYYYMMDD");
    return {
      authentication,
      transitionName: "",
      startDate: dayjs(queryStart, "YYYYMMDD").toDate(),
      endDate: dayjs(queryEnd, "YYYYMMDD").toDate(),
      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      lastday: todayD
        .add(-1, "d")
        .startOf("day")
        .format("YYYY-MM-DD"),
      parPage: 10,
      currentPage: 1,
      showDialog: false,
      listItem: [],
      total: 0,
      listLoading: false,
      dialoglistItem: []
    };
  },
  async created() {
    this.callFunctions();
  },
  computed: {
    getPageCount(): number {
      return this.total ? Math.ceil(this.total / this.parPage) : 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
      this.callFunctions();
    },
    callFunctions() {
      this.listLoading = true;
      const functions = firebaseProject.functions("asia-northeast1");
      const callable = functions.httpsCallable("consoleCouponUseCounts");
      const nowH = parseInt(dayjs().format("H"));
      let todayD = dayjs();
      if (nowH <= 4) {
        todayD = dayjs().add(-1, "day");
      }
      const alldayStart = todayD.add(-7, "d").format("YYYYMMDD");
      const dateStart = this.$route.query.start || alldayStart;
      const dateEnd =
        this.$route.query.end || todayD.add(-1, "d").format("YYYYMMDD");
      const params = {
        shopId: this.shopId,
        parPage: this.parPage,
        currentPage: this.currentPage,
        startTime: dayjs(dateStart as string)
          .startOf("day")
          .valueOf(),
        endTime: dayjs(dateEnd as string)
          .endOf("day")
          .valueOf()
      };
      callable(params)
        .then(res => {
          console.log(res);
          this.listLoading = false;
          if (res && res.data.status == "SUCCEED") {
            window.scrollTo(0, 0);
            this.listItem = res.data.coupon;
            this.total = res.data.maxNumber;
          }
        })
        .catch(e => {
          console.error(e);
          this.listLoading = false;
        });
    },

    async changeDate() {
      const start = dayjs(this.startDate).format("YYYYMMDD");
      const end = dayjs(this.endDate).format("YYYYMMDD");
      if (start > end) {
        alert({
          title: "エラー",
          text: "期間を正しく選択してください。"
        });
      }
      // 期間エラーの場合もデータの更新は行う→0件になる
      this.$router.replace({
        query: { start: String(start), end: String(end) }
      });
      await this.callFunctions();
    },
    openDetailModal(id: string) {
      this.dialoglistItem = [];
      this.listLoading = true;
      const functions = firebaseProject.functions("asia-northeast1");
      const callable = functions.httpsCallable("consoleCouponUseCountsDetail");
      const nowH = parseInt(dayjs().format("H"));
      let todayD = dayjs();
      if (nowH <= 4) {
        todayD = dayjs().add(-1, "day");
      }
      const alldayStart = todayD.add(-7, "d").format("YYYYMMDD");
      const dateStart = this.$route.query.start || alldayStart;
      const dateEnd =
        this.$route.query.end || todayD.add(-1, "d").format("YYYYMMDD");
      const params = {
        shopId: this.shopId,
        couponId: id,
        startTime: dayjs(dateStart as string)
          .startOf("day")
          .valueOf(),
        endTime: dayjs(dateEnd as string)
          .endOf("day")
          .valueOf()
      };
      callable(params)
        .then(res => {
          console.log(res);
          this.listLoading = false;
          this.showDialog = true;
          if (res && res.data.status == "SUCCEED") {
            this.dialoglistItem = res.data.coupon;
          }
        })
        .catch(e => {
          this.listLoading = false;
          console.error(e);
        });
    },
    closeDetailModal() {
      this.showDialog = false;
    }
  }
});
